import axios, { AxiosResponse } from 'axios';
import { KIT_API_BASE_URL } from '../../constants';
import { GetBarcodeFormPayload, KitValidationResponse } from '../../models/barcode';

export default class BarcodeService {

  static async get(payload: GetBarcodeFormPayload) {
    const response: AxiosResponse<KitValidationResponse> = await axios.get(`${KIT_API_BASE_URL}/v1.0/kit?code=${payload.barcode}&shallow=true`);
    return response.data;
  }

}